import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Text,
} from "@src/appV2/redesign/system/ui-components";

export function TransfereeRulesInfo() {
  return (
    <List sx={{ p: 2 }}>
      <ListItem>
        <ListItemIcon iconType="help-outlined" />
        <ListItemText
          primary={
            <Text variant="body1">
              A professional wants to transfer one of their booked shifts to you. If you accept, you
              will be able to work the shift.
            </Text>
          }
        />
      </ListItem>
      <ListItem>
        <ListItemIcon iconType="triangle-exclamation" />
        <ListItemText
          primary={
            <Text variant="body1">
              If you cancel or No Call No Show, the transferrer will lose 30 points.
            </Text>
          }
        />
      </ListItem>

      <ListItem>
        <ListItemIcon iconType="triangle-exclamation" />
        <ListItemText
          primary={
            <Text variant="body1">
              {`If you work this shift on time, you will get points. The transferrer won't.`}
            </Text>
          }
        />
      </ListItem>
      <ListItem>
        <ListItemIcon iconType="triangle-exclamation" />
        <ListItemText
          primary={
            <Text variant="body1">
              Shifts can only be transfered once. You CANNOT transfer this shift to someone else.
            </Text>
          }
        />
      </ListItem>
    </List>
  );
}
